import React, {useState, useEffect, useCallback, memo} from 'react';
import {useDispatch, useSelector} from "react-redux";
import FilterBarHeader from "./FilterBarHeader";
import Utils from "@/utils/Default/Utils";
import dynamic from "next/dynamic";
import {
    UPDATE_ALERT_NO_STORE_STATUS,
    UPDATE_GEOLOCATION_STATUS,
    UPDATE_IS_CUSTOMER_LOCATION_CHANGED
} from "@/redux/reducers/Default/actionsTypes";
import {FILTER_AVAILABILITY_SHOP_ID_LIST_CODE} from "@/utils/constants";
import AvailabilityFilterUtils from "@/utils/Default/AvailabilityFilterUtils";
import {triggerAvailabilityShopFilter} from "@/animations/Default/productListPage";

const FilterBarShopGeoLocationWithNoSSR = dynamic(
    () => import('./FilterBarShopGeoLocation'),
    {ssr: false}
)
const FilterBarShopListWithNoSSR = dynamic(
    () => import('./FilterBarShopList'),
    {ssr: false}
)
export const LocationStore = memo(({
                                  availabilityFilter,
                                  productListParams,
                                  applyFilters,
                                  currentFiltersValue,
                                  showAvailabilityFilter,
                                  changeFromClient
                              }) => {
    const dispatch = useDispatch();
    const shopName = useSelector(state => state.header?.shop?.shopInfos?.name);
    const stockLocator = useSelector(state => state.stockLocator);
    const isCustomerLocationChanged = stockLocator.isCustomerLocationChanged;
    const alertGeolocation = stockLocator.alertGeolocation ? 'fadeIn' : 'hidden';
    const alertNoStore = stockLocator.alertNoStore ? 'fadeIn' : 'hidden';
    let seeAllAvailableProductFilter = availabilityFilter?.length > 0 ? availabilityFilter[0][5].filter(item => item[2] === 'all')[0] : null;
    let cityName = (seeAllAvailableProductFilter) ? Utils.getMetaInfosValueByCode("city", seeAllAvailableProductFilter[6]) :""
    let zipCodeValue = (seeAllAvailableProductFilter) ? Utils.getMetaInfosValueByCode("zipCode", seeAllAvailableProductFilter[6]) : ""
    const [dropdownActive, setDropdownActive] = useState("hidden")
    const [alertInfo, setAlertInfo] = useState("visible")
    const [filterCity, setFilterCity] = useState('')
    const [checkboxCounter, setCheckboxCounter] = useState(4)
    const [city, setCity] = useState(cityName)
    const [zipCode, setZipCode] = useState(zipCodeValue)
    const [isAvailabilityFilterActive, setIsAvailabilityFilterActive] = useState(false)
    const [selectedCity, setSelectedCity] = useState(shopName ? shopName : '')
    const resetMagList = () => {
        let appliedShop = availabilityFilter?.length > 0 ? availabilityFilter[0][5]?.filter(item => item[5]) : []
        setCheckboxCounter(appliedShop?.length ? appliedShop.length : 0)
    }
    useEffect(() => {
        let isActiveAvailabilityFilter = availabilityFilter?.length > 0 ? availabilityFilter[0][5].filter(item => item[5]) : null;
        setIsAvailabilityFilterActive((isActiveAvailabilityFilter?.length > 0))
        resetMagList()
        setCity(seeAllAvailableProductFilter ? Utils.getDataFromShopCircle("city") ? Utils.getDataFromShopCircle("city") : Utils.getMetaInfosValueByCode("city", seeAllAvailableProductFilter[6]) : Utils.getDataFromShopCircle("city"))
        setZipCode(seeAllAvailableProductFilter ? Utils.getDataFromShopCircle("zipCode") ? Utils.getDataFromShopCircle("zipCode") : Utils.getMetaInfosValueByCode("zipCode", seeAllAvailableProductFilter[6]) : Utils.getDataFromShopCircle("zipCode"))
        if (isCustomerLocationChanged === true) {
            dispatch({
                type: UPDATE_IS_CUSTOMER_LOCATION_CHANGED,
                payload: {
                    value: false
                }
            })
        }

    }, [shopName, seeAllAvailableProductFilter, isCustomerLocationChanged])
    useEffect(() => {
        if (shopName?.length > 0 && shopName !== selectedCity) {
            setCity(Utils.getDataFromShopCircle("city") ? Utils.getDataFromShopCircle("city") : '')
            setZipCode(Utils.getDataFromShopCircle("zipCode") ? Utils.getDataFromShopCircle("zipCode") : '')
            setSelectedCity(shopName)
        }
    }, [shopName, seeAllAvailableProductFilter])
    useEffect(() => {
        resetMagList()
        const timerAlert = setTimeout(() => {
            setAlertInfo('fadeOut')
            setTimeout(() => {
                setAlertInfo('hidden')
            }, 300);
        }, 10700);
        return () => clearTimeout(timerAlert);
    }, []);
    const closeAlert = () => {
        setAlertInfo('fadeOut')
        setTimeout(() => {
            setAlertInfo('hidden')
        }, 300);
    }

    const toggleCheckBox = (event) => {
        event.stopPropagation()
        event.nativeEvent.stopImmediatePropagation()
        event.preventDefault()
        const code = event.currentTarget.getAttribute('data-code');
        if (code === FILTER_AVAILABILITY_SHOP_ID_LIST_CODE) {
            triggerAvailabilityShopFilter(!currentFiltersValue[code] ? 'filter_add' : 'filter_delete')
        }
    }

    const handleDropdownActive = useCallback((event, dropdownState) => {
        setDropdownActive(dropdownState);
        if (dropdownState === 'storeActive' || dropdownState === 'delayActive') {
            dispatch({
                type: UPDATE_ALERT_NO_STORE_STATUS,
                payload: {
                    value: false
                }
            })
            dispatch({
                type: UPDATE_GEOLOCATION_STATUS,
                payload: {
                    value: false
                }
            })
        }
        alertInfo == "visible" && closeAlert()
    }, [])

    const handleClick = (event) => {
        event.preventDefault()
        if (selectedCity != "") {
            if (seeAllAvailableProductFilter) {
                applyFilters(event, seeAllAvailableProductFilter, "apply", FILTER_AVAILABILITY_SHOP_ID_LIST_CODE)
            } else {
                const filterItem = getAvailabilityFilterAll(availabilityFilter[0][5])
                applyFilters(event, filterItem, "apply", FILTER_AVAILABILITY_SHOP_ID_LIST_CODE)
            }
        }
        triggerAvailabilityShopFilter('filter_add', availabilityFilter?.length > 0 ? availabilityFilter[0][1] : null)
    }
    const getAvailabilityFilterAll = () => {
        const filtredValues = AvailabilityFilterUtils.filterAvailibilityValuesByShopCircle((availabilityFilter[0][5]))
        let filterAvailabilityValueAll = ''
        filtredValues.forEach((filterValue) => {
            if (filterValue[3] !== '') {
                filterAvailabilityValueAll += filterAvailabilityValueAll != '' ? '/' + filterValue[3] : filterValue[3];
            }
        });
        return [FILTER_AVAILABILITY_SHOP_ID_LIST_CODE, '', 'all', filterAvailabilityValueAll, '', false,
            {codes: [], items: []}]
    }

    const countCheckBox = (e) => {
        if (e.target.checked) {
            setCheckboxCounter(checkboxCounter + 1)
        } else {
            setCheckboxCounter(checkboxCounter - 1)
        }
    }
    return (

        <div className={`dp__header__filter-bar__location-store ${dropdownActive}`}>
            <FilterBarHeader selectedCity={selectedCity} city={city} handleDropdownActive={handleDropdownActive}
                             zipCode={zipCode}/>
            {showAvailabilityFilter && <div className="dp__header__filter-bar__location-store__delay ">
                <button onMouseOver={(event) => handleDropdownActive(event, "delayActive")}  onClick={(event) => handleClick(event)}
                        className={checkboxCounter > 0 && isAvailabilityFilterActive ? "active" : null}>Retrait 2h
                </button>
            </div>}
            <div
                className={`dp__header__filter-bar__location-store__location-dropdown ${dropdownActive} ${selectedCity != '' ? "selected" : "no-selected"}`}
                onMouseLeave={() => {
                    setFilterCity('')
                }}>
                <div>
                    {selectedCity === "" ?
                        <p><strong>Saisissez votre code postal pour voir les
                            {dropdownActive === "storeActive" &&
                                " délais et options de livraison ainsi que les disponibilités en magasin"}
                            {dropdownActive === "delayActive" &&
                                " produits disponibles sous 2h dans les magasins BUT près de chez vous"}</strong></p> :
                        dropdownActive === "storeActive" &&
                        <p><span>Votre magasin : </span> <strong> {shopName} </strong></p>
                    }
                    {(dropdownActive !== "delayActive") || (selectedCity === "" && dropdownActive === "delayActive") ?
                        <FilterBarShopGeoLocationWithNoSSR selectedCity={selectedCity}
                                                           productListParams={productListParams}
                                                           alertGeolocation={alertGeolocation}
                                                           alertNoStore={alertNoStore} rattachedFrom={dropdownActive}/>
                        :
                        <FilterBarShopListWithNoSSR applyFilters={applyFilters}
                                                    currentFiltersValue={currentFiltersValue}
                                                    availabilityFilter={availabilityFilter?.length > 0 ? availabilityFilter[0] : null}
                                                    countCheckBox={countCheckBox}
                                                    changeFromClient={changeFromClient}
                                                    toggleCheckBox={toggleCheckBox} />
                    }
                </div>
            </div>
            <p className={`dp__header__filter-bar__location-store__alertInfo ${alertInfo}`} role="alert">
                Retrouvez les délais et options de livraison ainsi que les disponibilités en magasin
                <button type="button" aria-label="Fermer" onClick={closeAlert}></button>
            </p>
        </div>
    )
})
